import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import GoogleLogin from '../../components/auth/GoogleLogin';
import { useAuth } from '../../contexts/AuthContext';

const Login = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to dashboard if user is already authenticated
    if (isAuthenticated) {
      navigate('/dashboard');
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className="login-container">
      <div className="login-card">
        <h1>Cartoon Us</h1>
        <p>Transform your photos into Studio Ghibli-style artwork</p>
        
        <div className="login-options">
          <div className="login-option">
            <h3>Sign in with Google</h3>
            <GoogleLogin />
          </div>
        </div>
        
        <div className="login-footer">
          <p>By signing in, you agree to our Terms of Service and Privacy Policy</p>
        </div>
      </div>
    </div>
  );
};

export default Login; 